import React, { useEffect, useRef, useState } from 'react';

let turnstileScriptPromise;

const loadTurnstile = () => {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!turnstileScriptPromise) {
    turnstileScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.onload = () => window.turnstile
        ? resolve(window.turnstile)
        : reject(new Error('Turnstile did not initialize.'));
      script.onerror = () => reject(new Error('Turnstile could not load.'));
      document.head.appendChild(script);
    }).catch((error) => {
      turnstileScriptPromise = null;
      throw error;
    });
  }
  return turnstileScriptPromise;
};

const TurnstileWidget = ({ action, onToken }) => {
  const containerRef = useRef(null);
  const onTokenRef = useRef(onToken);
  const [unavailable, setUnavailable] = useState(false);
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

  onTokenRef.current = onToken;

  useEffect(() => {
    let cancelled = false;
    let widgetId;

    if (!siteKey) {
      setUnavailable(true);
      onTokenRef.current(null);
      return undefined;
    }

    setUnavailable(false);
    onTokenRef.current(null);

    loadTurnstile().then((turnstile) => {
      if (cancelled || !containerRef.current) return;
      widgetId = turnstile.render(containerRef.current, {
        sitekey: siteKey,
        action,
        callback: (token) => onTokenRef.current(token),
        'expired-callback': () => onTokenRef.current(null),
        'error-callback': () => {
          setUnavailable(true);
          onTokenRef.current(null);
        },
      });
    }).catch(() => {
      if (cancelled) return;
      setUnavailable(true);
      onTokenRef.current(null);
    });

    return () => {
      cancelled = true;
      if (widgetId && window.turnstile) window.turnstile.remove(widgetId);
    };
  }, [action, siteKey]);

  return (
    <div style={{ margin: '14px 0', minHeight: 65 }}>
      <div ref={containerRef} />
      {unavailable ? (
        <p role="status">Verification could not load. Refresh the page and try again.</p>
      ) : null}
    </div>
  );
};

export default TurnstileWidget;
